import { Pipe, PipeTransform } from "@angular/core";

import { FileSizeService } from "@lantern/app/core/utils/pipe-services";

@Pipe({
  name: "taFileSize",
  pure: true
})
export class FileSizePipe implements PipeTransform {
  constructor(private fileSizeService: FileSizeService) {}

  transform(input: string | number): string {
    return this.fileSizeService.transform(input);
  }
}
